import React from "react";
import ReactDOM from "react-dom/client";
import CameraFeed from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<CameraFeed />);
